import template1 from "../assets/template1.png"
import template2 from "../assets/template2.png";
import template3 from "../assets/template3.png";
import completeproject from "../assets/completeproject.png";
import quizapp from "../assets/quizapp.png";
import todolist from "../assets/todolist.png";
import foodapp from "../assets/foodapp.png";
import mtdb from '../assets/mtdb.png'
import fashionstore from '../assets/fashionstore.png'
// import expensetracker from "../assets/expensetracker.png";

export const MyProjects = [
    {
        id: "p1",
        name: "Template 1",
        tools: ["HTML", "CSS"],
        image: template1,
        github: "https://github.com/YahiaElsayed19/Template1",
        live: "https://yahiaelsayed19.github.io/Template1/",
    },
    {
        id: "p2",
        name: "Template 2",
        tools: ["HTML", "CSS"],
        image: template2,
        github: "https://github.com/YahiaElsayed19/Template2",
        live: "https://yahiaelsayed19.github.io/Template2/",
    },
    {
        id: "p3",
        name: "Template 3",
        tools: ["HTML", "CSS", "JS"],
        image: template3,
        github: "https://github.com/YahiaElsayed19/Template3",
        live: "https://yahiaelsayed19.github.io/Template3/",
    },
    {
        id: "p4",
        name: "Complete Project",
        tools: ["HTML", "CSS", "JS"],
        image: completeproject,
        github: "https://github.com/YahiaElsayed19/Complete-Project",
        live: "https://yahiaelsayed19.github.io/Complete-Project/",
    },
    {
        id: "p5",
        name: "Quiz App",
        tools: ["HTML", "CSS", "JS"],
        image: quizapp,
        github: "https://github.com/YahiaElsayed19/Quiz-App",
        live: "https://yahiaelsayed19.github.io/Quiz-App/",
    },
    {
        id: "p6",
        name: "To-Do List App",
        tools: ["HTML", "CSS", "JS"],
        image: todolist,
        github: "https://github.com/YahiaElsayed19/To-do-List",
        live: "https://yahiaelsayed19.github.io/To-do-List/",
    },
    {
        id: "p8",
        name: "Complete food order app",
        tools: ["React.js", "CSS"],
        image: foodapp,
        github: "https://github.com/YahiaElsayed19/Food-order-app",
        live: "https://food-order-app-yahia.vercel.app/",
    },
    {
        id: "p9",
        name: "Complete Movies and Tv Shows Database",
        tools: ["React.js", "CSS", "Axios", "React router", "Framer motion"],
        image: mtdb,
        github: "https://github.com/YahiaElsayed19/MTDB",
        live: "https://mtdb.vercel.app/",
    },
    {
        id: "p10",
        name: "Fashion store",
        tools: ["Next.js", "TypeScript","Tailwaind", "MongoDB","Axios","Framer motion"],
        image: fashionstore,
        github: "https://github.com/YahiaElsayed19/fashion-store",
        live: "https://fashion-store-next.vercel.app/",
    },
];
// {
//     id: "p7",
//     name: "Complete expanse tracker app",
//     tools: ["React.js", "CSS"],
//     image: expensetracker,
//     github: "https://github.com/YahiaElsayed19/expense",
//     live: "https://expense-tracker.yahia.vercel.app/",
// },
